module.exports = __webpack_public_path__ + "img/Djibouti.a85f531a.svg";